<template>
  <zh-table-page
    ref="tableRef"
    v-bind="{
      title: '服务器管理',
      search,
      api,
      afterGetDetail,
      beforeSave,
      ...table,
      ...dialog,
    }"
  >
  </zh-table-page>

</template>
<script>
import {
  defineComponent,
  reactive,
  ref,
  toRefs,
  getCurrentInstance,
  onMounted,
  watch,
  computed,
} from "vue";
import { useRouter } from "vue-router";
import { ElMessageBox } from "element-plus";
import moment from "moment"
import { fa } from "element-plus/es/locale";
export default defineComponent({
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const tableRef = ref();
    const state = reactive({
      search: [
        {
          label: "服务器名称",
          placeholder: "服务器名称",
          value: "serverName",
        },
        {
          component: "zh-select",
          label: "服务器类型",
          placeholder: "服务器类型",
          value: "serverType",
          options:[
              {value:1,label:'云服务器 '},
              {value:2,label:'实体服务器 '},
              {value:3,label:'虚拟机 '},
          ],
         
        },
        {
          component: "zh-select",
          label: "服务器分类",
          placeholder: "服务器分类",
          value: "serverClassification",
          options:[
              {value:1,label:'国润服务器 '},
              {value:2,label:'内网服务器 '},
          ],
         
        },
      ],
      api: {
        list: "postServerPage",
        delete: "deleteServerDelete",
        add: "postServerSave",
        edit: "postServerUpdate",
        detail: "getServer",
        tree: "",
      },
      table: {
        columns: [
          { label: "服务器名称", prop: "serverName" },
          { label: "服务器类型", prop: "serverType", width: "110",
          scopeFun: (scope) => {
            if (scope.row.serverType) {
              return scope.row.serverType.desc;
            }
            return '--'

          },
          },
          { label: "服务器分类", prop: "serverClassification", width: "110",
          scopeFun: (scope) => {
            if (scope.row.serverClassification) {
              return scope.row.serverClassification.desc;
            }
            return '--'
          }, },
          { label: "内网ip", prop: "intranetIp",},
          { label: "外网ip", prop: "publicIp"},
          { label: "CPU", prop: "cpu"},
          { label: "内存", prop: "memory",  scopeFun: (scope) => {
            if (scope.row.memory) {
              return scope.row.memory +'G';
            }
            return '--'

          },},
          { label: "到期时间", prop: "expirationTime",
      },
          { label: "硬盘总量", prop: "hardDisk", scopeFun: (scope) => {
            if (scope.row.hardDisk) {
              return scope.row.hardDisk +'G';
            }
            return '--'

          }},
          { label: "剩余硬盘大小", prop: "hardDiskSurplus", scopeFun: (scope) => {
            if (scope.row.hardDiskSurplus) {
              return scope.row.hardDiskSurplus +'G';
            }
            return '--'

          }},
          
        ],
        operations: [
          { label: "详情" },
          { label: "编辑" },
          { label: "删除", type: "danger" },
        ],
        rowKey: "id",
      },
      dialog: {
        dialogForm: [
          {
            label: "服务器名称",
            placeholder: "请输入服务器名称",
            value: "serverName",
          },
          {
            component: "zh-select",
            label: "服务器类型",
            placeholder: "请选择服务器类型",
            value: "serverType",
            options:[
              {value:1,label:'云服务器 '},
              {value:2,label:'实体服务器 '},
              {value:3,label:'虚拟机 '},
            ],
          },
          {
            component: "zh-select",
            label: "服务器分类",
            placeholder: "请选择服务器分类",
            value: "serverClassification",
            options:[
              {value:1,label:'国润服务器 '},
              {value:2,label:'内网服务器 '},
            ],
          },
          {
            label: "内网ip",
            placeholder: "请输入内网ip",
            value: "intranetIp",
          },
          {
            label: "外网ip",
            placeholder: "请输入外网ip",
            value: "publicIp",
          },
          {
            label: "硬盘总量",
            placeholder: "请输入硬盘总量",
            value: "hardDisk",
            append:"G"
          },
          {
            label: "内存",
            placeholder: "请输入内存",
            value: "memory",
            append:"G"
          },
          {
            label: "服务器系统镜像	",
            placeholder: "请输入服务器系统镜像",
            value: "systemImage",
          },
          {
            label: "cpu	",
            placeholder: "请输入cpu",
            value: "cpu",
          },
          {
            label: "远程连接方式	",
            placeholder: "请输入远程连接方式",
            value: "remoteConnection",
          },
          {
            component: "zh-select",
            label: "所属服务器",
            placeholder: "请选择所属服务器",
            value: "belongId",
            url:"postServerList",
            field: {
              id: "value",
              serverName: "label",
            },
            params: {
              serverType: 2,
            },
            
            showCondition:(item)=>{
              return item.serverType === 3
            },
            disabledFun:(item)=>{
              if(item.id){
                return true
              }
              return false
            },
          },
          {
            label: "带宽",
            placeholder: "请输入带宽",
            value: "bandwidth",
            showCondition:(item)=>{
              return item.serverType === 1
            },
            disabledFun:(item)=>{
              if(item.id){
                return true
              }
              return false
            },
          },
          {
            component: "zh-select",
            label: "是否备份",
            placeholder: "请选择是否备份",
            value: "snapshot",
            options:[
              {value:0,label:'不备份 '},
              {value:1,label:'备份 '},
            ],
            showCondition:(item)=>{
              return item.serverType === 1
            },
            disabledFun:(item)=>{
              if(item.id){
                return true
              }
              return false
            },
          },
          {
            component: "zh-date-picker",
            label: "到期时间",
            placeholder: "请选择到期时间",
            value: "expirationTime",
            type:'datetime'
          },
          {
            label: "相关描述",
            placeholder: "请输入内容",
            value: "description",
            type: "textarea",
          },
        ],
        dialogRules: {
          serverName: [
            { required: true, message: "服务器名称不能为空", trigger: "blur" },
          ],
          serverType: [
            { required: true, message: "服务器类型不能为空", trigger: "blur" },
          ],
          serverClassification: [
            { required: true, message: "服务器分类不能为空", trigger: "blur" },
          ],
          intranetIp: [
            { required: true, message: "内网ip不能为空", trigger: "blur" },
          ],
          // publicIp: [
          //   { required: true, message: "外网ip不能为空", trigger: "blur" },
          // ],
          hardDisk: [
            { required: true, message: "硬盘总量不能为空", trigger: "blur" },
          ],
          belongId: [
            { required: true, message: "belongId不能为空", trigger: "blur" },
          ],
          serverId: [
            { required: true, message: "请选择服务器", trigger: "blur" },
          ],
          // expirationTime: [
          //   { required: true, message: "到期时间不能为空", trigger: "blur" },
          // ],
         
        },
      },
    });
    onMounted(() => {
    });
    //点击编辑处理详情数据
    const afterGetDetail = (data) => {
      return {
        ...data,
        serverClassification: data.serverClassification?.value ?? 1,
        serverType: data.serverType?.value ?? 1,
      };
    };
    //新增编辑保存之前
    const beforeSave = (form)=>{
      return {
        ...form,
        expirationTime:moment(form.expirationTime).format('YYYY-MM-DD HH:ss:mm')
      }
    }

    return {
      ...toRefs(state),
      tableRef,
      afterGetDetail,
      beforeSave,
    };
  },
});
</script>
